import React from 'react'

import './style.css'

const DateWarningTicker = ({ position = 'fixed' }) => {
  const headerHeight = document.getElementById('main-header-wrap')?.offsetHeight

  return (
    <div
      className="date-warning-message absolute has-background-danger has-text-white p-1"
      style={{ top: headerHeight }}
    >
      Enter Dates for most accurate pricing
    </div>
  )
}

export default DateWarningTicker
